import { Box, Text } from '@factorialco/deprecated-design-system'

import BenefitCard from './_BenefitCard'

interface BenefitsLandingContentProps {
  content: {
    mainMessage: {
      title: string
    }
    benefits: Array<{
      id: string
      title: string
      description: string
      media: {
        src: string
        alt: string
      }
    }>
  }
}

const BenefitsLandingContent = ({ content }: BenefitsLandingContentProps) => {
  return (
    <Box gap="s80" style={{ maxWidth: '1040px', margin: '0 auto' }}>
      <Box
        style={{ maxWidth: '700px', margin: '0 auto' }}
        alignItems="center"
        textAlign="center"
        padding="s24"
      >
        <Text color="black" size="500" weight="bold">
          {content.mainMessage.title}
        </Text>
      </Box>
      <Box gap="s120" justifyContent="spaceAround">
        {content.benefits.map((benefit, index) => (
          <BenefitCard
            key={benefit.id}
            benefit={benefit}
            imagePosition={index % 2 === 0 ? 'left' : 'right'}
          />
        ))}
      </Box>
    </Box>
  )
}

export default BenefitsLandingContent
